// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'

import Fullparent from '@/directives/fullparent'
import FmTableMenu from '@/components_bit/FmTableMenu'

import mainInit from '@/cllib/app_init'

Vue.component(FmTableMenu.name, FmTableMenu)

Vue.directive(Fullparent.name, Fullparent)

sync(store, router)

mainInit()

Vue.use(ElementUI)
window.echarts = require('echarts')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js